class Alerts {
    constructor(alerts) {
        this.slides = Array.from(alerts.querySelectorAll('.site-alert'));

        this.splide = new Splide(alerts, {
            arrows: false,
            pagination: this.slides.length > 1,
            drag: this.slides.length > 1,
            perPage: 1,
            type: 'loop',
            gap: '1rem'
        }).mount();

        this.slides.forEach((slide) => {
            slide.querySelector('.site-alert__dismiss').addEventListener('click', (e) => {
                e.preventDefault();
                this.dismiss();
            });
        });
    }

    dismiss = () => {
        this.slides.forEach((slide) => {
            App.Cookies.setItem('AlertDismissed-' + slide.dataset.alertid, 'true', Infinity, '/', window.location.hostname, window.location.protocol === 'https:');
        });
        document.querySelector('.site-alerts').classList.add('site-alerts--dismissed');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const alerts = document.querySelector('.site-alerts .splide');
    if (alerts) {
        new Alerts(alerts);
    }
});